import { default as GlobalContent2Up } from 'components/Content2Up';

export default function Content2Up(props) {
  const {
    content2up: {
      anchor_id: anchorId,
      badge_image: badge,
      background_color: backgroundColor,
      content: bodyText,
      ctatext: ctaText,
      ctaurl: ctaUrl,
      heading,
      header_type: headingTag,
      heroimage,
      herotitle,
      herourl,
      reverse_rows: isRowReverse,
      link_text: linkText,
      link_url: linkUrl,
      text_color: textColor,
      use_small_heading: useSmallHeading,
    },
  } = props;
  return (
    <GlobalContent2Up
      isSetDangerously
      anchorId={anchorId}
      backgroundColor={backgroundColor}
      badge={badge || { title: '', url: '' }}
      bodyText={bodyText}
      ctaText={ctaText}
      ctaUrl={ctaUrl}
      heading={heading}
      headingTag={headingTag}
      hero={{ title: herotitle, url: heroimage?.url, link: herourl }}
      isRowReverse={isRowReverse}
      linkText={linkText}
      linkUrl={linkUrl}
      textColor={textColor}
      useSmallHeading={useSmallHeading}
    />
  );
}
